import * as React from 'react';
import { Page } from '~/components/technology-qa-page/technology-qa-page';

const TechnologyPage: React.FC = () => <Page />;

export default TechnologyPage;
